'use strict';

import React      from 'react';
import PropTypes  from 'prop-types';
import NavBarItem from './NavBarItem';
import { generateKey } from '../../utils/CommonUtils';

class NavBar extends React.PureComponent {

	render() {
		const navBarElements = this.props.navLinks.map((entry, idx) => <NavBarItem key={generateKey(entry.caption.toLowerCase(), idx)} {...entry} />);
		return <ul id="navbar-active" className="navigation__list--usercentral navbar__list">{navBarElements}</ul>;
	}
}

NavBar.propTypes = {
	navLinks: PropTypes.arrayOf(
		PropTypes.shape({
			caption:       PropTypes.string,
			link:          PropTypes.string,
			isHighlighted: PropTypes.bool,
			isNew:         PropTypes.bool,
			hasSale:       PropTypes.bool,
			subNavigation: PropTypes.array,
		})
	),
};

export default NavBar;
